import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper'; 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import FormControl from '@mui/material/FormControl'; 
import InputLabel from '@mui/material/InputLabel';   
import Select from '@mui/material/Select';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';   
import psdfimage from './images/psdfimage.png';




const useStyles = styled({ 
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Accountspayabledetailedreport extends Component {
	 constructor(props) {
    super(props);
	
	
var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}


 this.state = { 

	open:false,
	ColumnData:[],todate1: strdob.getFullYear() + '-' + month + '-' + (strdob.getDate()), todate: new Date(strdob.getFullYear(), strdob.getMonth(), 1),
	redirect:false,pagename:'',sinid:'',id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	search:'',order:'desc' ,orderBy:'',custid:'',pdflogo:'',
	Vendorbilldata:[],sinidies:'',totalrecords:0,selectedcount:0,custsort:'total_due desc',	
	
	}
   
}

componentWillMount() {
	
	document.title = "Isifol - Sales Invoice";	
 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
this.ColumheaderinvoiceApi();
	this.apicall(this.state.page,this.state.rowsPerPage);	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
		  
	let strname="A/P Aging Breakdown";
			   
	this.props.parentdasCallback(
				strname+"~"
			);	
			


}	

PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=30')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
    	this.ColumheaderinvoiceApi();
	this.apicall(this.state.page,this.state.rowsPerPage);	

      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
myChangeHandler = (event) => {
	
  let nam = event.target.name;
  let val = event.target.value;
  
 
  
  this.setState({[nam]: val});
  

 } 	
 
 
 
 
ColumheaderinvoiceApi(){
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxbusinesssetting.php?action=getall&bs_cmp_id='+localStorage.getItem("ISIcmpid")+'&bs_id=7&bs_page=1')
     
  .then(resp => {  	
    if(resp.data.length>0){
		
			this.setState({  
			  ColumnData: resp.data,  
			   colcount:parseInt(resp.data[0].count),
			   	
			});

     }
});
}


todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
       todate: dayjs(dateObj),
        todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  }
	
	

apicall(page,rowsPerPage){
	 
   axios.get(localStorage.getItem("ISIurl")+'ajaxaccountsrecievablereport.php?action=payebledetailreportgetall&todate='+this.state.todate1+'&vb_cmp_id='+localStorage.getItem("ISIcmpid")+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&sorting='+this.state.custsort)
   .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Vendorbilldata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   totalrecords:parseInt(resp.data[0].count),
			   

		    });
			}
	 else{
		   this.setState({Vendorbilldata:[],totaldata:0});
	 }
 
 
    });
}



handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}

 handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    }; 
handleExportClick = (event) => {
  this.setState({ anchorEl: event.currentTarget });
};

handleClose = () => {
  this.setState({ anchorEl: null });
};

handleExportPDF = () => {
  this.handleDownload();
  this.handleClose();
};

handleExportCSV = () => {
  document.getElementById("test-table-xls-button").click();
  this.handleClose();
};	
handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}
handleDownload = () => {
  const { Vendorbilldata, ColumnData } = this.state;
  const doc = new jsPDF();


  const imgWidth = 40;
  const imgHeight = 12;
  const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
  const imgY = 10;
  if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }

 
  const title = 'Accounts Payable A/P Aging Breakdown Report';
  doc.setFontSize(16);
  const titleY = imgY + imgHeight + 8;
  doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });

  const tableStartY = titleY + 10;

 
  const agingColumns = Object.keys(Vendorbilldata[0] || {})
    .filter(key => key.startsWith('due_'))
    .sort((a, b) => {
      const getNum = key => parseInt(key.match(/\d+/)?.[0] || '9999', 10);
      return getNum(a) - getNum(b);
    });

  
  const dynamicHeaders = ColumnData.flatMap(col =>
    col.bs_value.split(',').map(val => val.trim())
  );


  const tableBody = [];
  let totalDue = 0;
  const agingTotals = {};
  agingColumns.forEach(col => { agingTotals[col] = 0; });

  Vendorbilldata.forEach(vendor => {
    // Vendor Name row (spans all columns)
    tableBody.push([
      { content: vendor.vendorname, colSpan: 5 + agingColumns.length + 1, styles: { fontStyle: 'bold' } }
    ]);

    if (vendor.productprice && vendor.productprice.length > 0) {
      vendor.productprice.forEach(item => {
        const row = [
          item.billdate || '',
          item.referenceno || '',
          parseFloat(item.total_due || 0).toFixed(2),
          item.duedate || '',
          parseFloat(item.total_due || 0).toFixed(2),
          ...agingColumns.map(col => parseFloat(item[col] || 0).toFixed(2)),
          '' 
        ];
        tableBody.push(row);
      });
    } else {
      tableBody.push([
        { content: 'No invoices for this vendor', colSpan: 5 + agingColumns.length + 1 }
      ]);
    }

    totalDue += parseFloat(vendor.total_due || 0);
    agingColumns.forEach(col => {
      agingTotals[col] += parseFloat(vendor[col] || 0);
    });
  });


  const totalRow = [
    '', '', '', 'Total',
    totalDue.toFixed(2),
    ...agingColumns.map(col => agingTotals[col].toFixed(2)),
    ''
  ];
  tableBody.push(totalRow);


  const headers = [[
    'Date',
    'Ref',
    'Total',
    'Due Date',
    'O/S Amt',
    ...dynamicHeaders,
    'Older'
  ]];

doc.autoTable({
  head: headers,
  body: tableBody,
  startY: tableStartY,
  theme: 'striped',
  styles: { fontSize: 9 },
  didDrawPage: function (data) {
    const str = "Page " + doc.internal.getNumberOfPages();
    doc.setFontSize(10);
    doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
  }
});

  doc.save('Accountspayable_AP_Aging_Breakdown_Report.pdf');
  this.handleCloseExportDialog();
};

	
		    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
	
	
 render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  
  if (
    !this.state.Vendorbilldata || 
    this.state.Vendorbilldata.length === 0
  ) {
    return <div>Loading...</div>;
  }



  const agingColumns = Object.keys(this.state.Vendorbilldata[0])
    .filter(key => key.startsWith('due_'))
    .sort((a, b) => {
      const getNum = key => parseInt(key.match(/\d+/)?.[0] || '9999', 10);
      return getNum(a) - getNum(b);
    });
const totalRow = {
  totalDue: 0,
  agingTotals: {}
};


this.state.Vendorbilldata.forEach(item => {
  totalRow.totalDue += parseFloat(item.total_due || 0);

  agingColumns.forEach(col => {
    if (!totalRow.agingTotals[col]) {
      totalRow.agingTotals[col] = 0;
    }
    totalRow.agingTotals[col] += parseFloat(item[col] || 0);
  });
});
  
  return (
 
		<React.Fragment> 
		<div className="searchbox">
		 
		
		
		
		 
		<ul>
		
<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate1) }
className="txtbox"
onChange={this.todatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
	<li>
	<p><p>Sort by</p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="custsort"
  value={this.state.custsort}
  name="custsort"
  inputProps={{tabIndex: "4"}}
        ><option value="total_due desc">Outstanding Amount</option>
	<option value="vendorname Asc">Name</option>
	
	
  </Select></p>
	</li>
	<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Calculate 
</Button>

&nbsp;&nbsp;

<a href="#/Accountspayablereport">    <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Summary
</Button></a>






&nbsp;&nbsp;
			
			<Button variant="contained" color="primary" className="exportbtn" onClick={this.handleOpenExportDialog} > EXPORT
             </Button>
			






  
      </p>
		
</li>

</ul>
</div>

<div className="clear"></div>

<div className="">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
         <TableRow>
		  <TableCell>Date</TableCell>
		 <TableCell>Reference</TableCell>
		 	 <TableCell>Total</TableCell>
			 	 <TableCell>Due Date</TableCell>
		 <TableCell>O/S Amt</TableCell>
            {this.state.ColumnData.map((col, index) => 
      col.bs_value.split(',').map((val, i) => (
        <TableCell key={index + '-' + i}>{'<' + val}</TableCell>
      ))
    )}
	<TableCell>Older</TableCell>
          </TableRow>

        </TableHead>

  <TableBody>
  {this.state.totaldata !== 0 && (
    <React.Fragment>
    {this.state.Vendorbilldata.filter(vend => vend.productprice && vend.productprice.length > 0)
	.map((vendor, vendorIndex) => (
  <React.Fragment key={vendorIndex}>
    <TableRow>
      <TableCell colSpan={10}><strong>{vendor.vendorname}</strong></TableCell>
    </TableRow>

    {vendor.productprice && vendor.productprice.length > 0 ? (
      vendor.productprice.map((item, index) => (
        <TableRow key={vendorIndex + "-" + index}>
          <TableCell><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{item.billdate}</a></TableCell>
          <TableCell><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{item.referenceno}</a></TableCell>
          <TableCell><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{parseFloat(item.total_due || 0).toFixed(2)}</a></TableCell>
          <TableCell><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{item.duedate}</a></TableCell>
          <TableCell><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{parseFloat(item.total_due || 0).toFixed(2)}</a></TableCell>
          {agingColumns.map((col, colIndex) => (
            <TableCell key={colIndex}><a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{parseFloat(item[col] || 0).toFixed(2)}</a></TableCell>
          ))}
        </TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={10}>No invoices for this vendor</TableCell>
      </TableRow>
    )}
  </React.Fragment>
))}
	  <TableRow key="total-row">
  <TableCell />
  <TableCell /> 
    <TableCell /> 
	  <TableCell><strong>Total</strong> </TableCell> 
   <TableCell><strong>{'\u200B' + parseFloat(totalRow.totalDue || 0).toFixed(2)}</strong></TableCell>
  {agingColumns.map((col, index) => (
    <TableCell key={"total-" + index}>
      <strong>{'\u200B' + parseFloat(totalRow.agingTotals?.[col] || 0).toFixed(2)}</strong>
    </TableCell>
  ))}
</TableRow>
    </React.Fragment>
  )}
{this.state.totaldata === 0 &&  (
    <TableRow key="no-data">
      <TableCell align="center" colSpan={this.state.colcount}>
        No Records
      </TableCell>
    </TableRow>
  )}

</TableBody>


</Table>
  </TableContainer> 
  
  <Table id="detailedreport" style={{ display: 'none' }}> 
 <TableHead>
         <TableRow>
		  <TableCell>Date</TableCell>
		 <TableCell>Reference No.</TableCell>
		 	 <TableCell>Total</TableCell>
			 	 <TableCell>Due Date</TableCell>
		 <TableCell>O/S Amt</TableCell>
            {this.state.ColumnData.map((col, index) => 
      col.bs_value.split(',').map((val, i) => (
        <TableCell key={index + '-' + i}>{'<' + val}</TableCell>
      ))
    )}
	<TableCell>Older</TableCell>
          </TableRow>

        </TableHead>

  <TableBody>
  {this.state.totaldata !== 0 && (
    <React.Fragment>
    {this.state.Vendorbilldata.map((vendor, vendorIndex) => (
  <React.Fragment key={vendorIndex}>
    <TableRow>
      <TableCell colSpan={10}><strong>{vendor.vendorname}</strong></TableCell>
    </TableRow>

    {vendor.productprice && vendor.productprice.length > 0 ? (
      vendor.productprice.map((item, index) => (
        <TableRow key={vendorIndex + "-" + index}>
          <TableCell>{item.billdate}</TableCell>
          <TableCell>{item.referenceno}</TableCell>
          <TableCell>{'\u200B' + parseFloat(item.total_due || 0).toFixed(2)}</TableCell>
          <TableCell>{item.duedate}</TableCell>
          <TableCell>{'\u200B' + parseFloat(item.total_due || 0).toFixed(2)}</TableCell>
          {agingColumns.map((col, colIndex) => (
            <TableCell key={colIndex}>{'\u200B' + parseFloat(item[col] || 0).toFixed(2)}</TableCell>
          ))}
        </TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={10}>No invoices for this vendor</TableCell>
      </TableRow>
    )}
  </React.Fragment>
))}
	  <TableRow key="total-row">
  <TableCell />
  <TableCell /> 
    <TableCell /> 
	  <TableCell><strong>Total</strong> </TableCell> 
  <TableCell><strong>{'\u200B' + parseFloat(totalRow.totalDue || 0).toFixed(2)}</strong></TableCell>
  {agingColumns.map((col, index) => (
    <TableCell key={"total-" + index}>
      <strong>{'\u200B' + parseFloat(totalRow.agingTotals?.[col] || 0).toFixed(2)}</strong>
    </TableCell>
  ))}
</TableRow>
    </React.Fragment>
  )} 
  
  {this.state.totaldata === 0 && (
    <TableRow key="no-data">
      <TableCell align="center" colSpan={this.state.colcount}>
        No Records
      </TableCell>
    </TableRow>
  )}

</TableBody>


</Table>
  </Paper>
   
 </div>



<Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Accounts Payable A/R Aging Breakdown Report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
				 <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
					
					
					<ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="my-custom-excel-button"
                    table="detailedreport"
                    filename="A/P Aging Breakdown Report"
                    sheet="A/P Aging Breakdown Report"
                    buttonText=""
                 variant="contained"/>
					
					
					
					
				
					
					
					
					
			
<img src={psdfimage} width={100} height={100} style={{ cursor: "pointer" }} onClick={this.handleClickOpen} alt="Download PDF" /></p>
</DialogContent>
<DialogActions>

<Button onClick={this.handleCloseExportDialog} color="primary"> Cancel </Button>
						
</DialogActions>
</Dialog>


</React.Fragment> 
 )
 }
}